<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableData"
      style="width: 100.1%"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableDataVue = {};
export default {
  name: "TableElasticLoadBalancingResourceGcp",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      subjectSearchKey: "",
      priorityId: "",
      columns: [
        {
          title: this.$t("RAM.ALI.ElasticLoadBalancer.accountName"),
          key: "accountName",
        },
        {
          title: this.$t("RAM.ALI.ElasticLoadBalancer.accountID"),
          key: "accountIdString",
        },

        {
          title: this.$t("RAM.GCP.ElasticLoadBalancer.accountTypeName"),
          key: "accountTypeName",
        },
        {
          title: this.$t("RAM.GCP.ElasticLoadBalancer.region"),
          key: "region",
        },
        {
          title: this.$t("RAM.ALI.ElasticLoadBalancer.ELBName"),
          key: "name",
        },
        {
          title: this.$t("RAM.ALI.ElasticLoadBalancer.loadbalancerType"),
          key: "loadbalancerType",
        },
        {
          title: this.$t("RAM.GCP.ElasticLoadBalancer.stateName"),
          key: "stateName",
        },
      ],
      tableData: [],
    };
  },
  beforeCreate: function () {
    tableDataVue = this;
  },
  created() {
    eventBus.$on("companyId", function (val) {
      tableDataVue.companyId = val;
    });
    eventBus.$on("loadbalancerId", function (val) {
      tableDataVue.loadbalancerId = val;
    });
    eventBus.$on("name", function (val) {
      tableDataVue.name = val;
    });
    eventBus.$on("accountIds", function (val) {
      tableDataVue.accountIds = val;
    });
    eventBus.$on("accountName", function (val) {
      tableDataVue.accountName = val;
    });
  },
  mounted: function () {
    // tableDataVue.getData();
  },
  methods: {
    showAll: function () {
      tableDataVue.getData();
    },
    // 分页显示数据
    /****************************************************/
    getData: function () {
      eventBus.$on("companyId", function (val) {
        tableDataVue.companyId = val;
      });
      eventBus.$on("loadbalancerId", function (val) {
        tableDataVue.loadbalancerId = val;
      });
      eventBus.$on("name", function (val) {
        tableDataVue.name = val;
      });
      eventBus.$on("accountIds", function (val) {
        tableDataVue.accountIds = val;
      });
      eventBus.$on("accountName", function (val) {
        tableDataVue.accountName = val;
      });
      this.$api.resourceManagement
        .selectGcpLoadBalancerByPage({
          companyId: this.companyId,
          loadbalancerId: this.loadbalancerId,
          name: this.name,
          accountIds: this.accountIds,
          accountName: this.accountName,
          pageNum: this.current,
          pageSize: this.pageSize,
        })
        .then((res) => {
          this.tableData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function (current) {
      this.current = current;
      tableDataVue.getData();
    },
    changeSize: function (pageSize) {
      this.pageSize = pageSize;
      tableDataVue.getData();
    },
  },
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/gcp/elb/TableElasticLoadBalancingResourceGcp.vue